import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';

import type { TAction } from '../../models';
import { handleError, handleNoAuthResultResponse } from '../../helpers';
import { verifyPhoneCode } from '../../../../helpers/api';
import { requestCode } from '../request-code';
import type { IApiErrorResponse } from '../../../../helpers/api/models';
import { retryAuthenticationViews, retryAuthenticationStatuses } from '../../config';

const onInputFinished: TAction = async ({ event: signCode, form, values }) => {
    const { change, getFieldState, getState } = form;

    try {
        const phone = getNumbersFromStr(getFieldState('phone')?.value);
        const { prodType } = values;

        change('confirmation.state', 'CODE_CHECKING');

        if (typeof signCode === 'string') {
            change('signCode', signCode);
            change('signCodeError', '');

            const { data } = await verifyPhoneCode({ phone, signCode, prodType });
            const { availableSignMethods, documentsWasSigned } = data;

            if (!documentsWasSigned) {
                handleNoAuthResultResponse({ availableSignMethods, change });

                return change('authenticationStep', 'checkConfirmationCode');
            }
        }

        change('confirmation.state', 'INITIAL');
        change('isAuthorized', true);
    } catch (error) {
        handleError(
            error as IApiErrorResponse,
            change,
            getState,
            retryAuthenticationViews,
            retryAuthenticationStatuses
        );
    }
};

const triggers: Record<string, TAction> = {
    onInputFinished,
    onSmsRetryClick: requestCode,
};

export const confirmCode: TAction = async ({ trigger, ...props }) => {
    if (typeof trigger === 'string') await triggers[trigger]({ trigger, ...props });
};
